import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import { GoogleMap, InfoWindow, Marker, useLoadScript } from '@react-google-maps/api';

import { FuneralHome } from '../../../static/models/FuneralHome';
import { SearchLocation } from '../../../static/models/SearchLocation';

const useStyles = makeStyles(() => ({
    infoWindow: {
        inlineSize: '150px',
        overflowWrap: 'break-word',
        maxHeight: '100px'
    },
    infoWindowName: {
        marginBottom: '5px'
    }
}));

const ProviderMap: React.FunctionComponent<PropShape> = props => {
    const classes = useStyles();
    const [recenterLatitude, setRecenterLatitude] = useState<number>();
    const [recenterLongitude, setRecenterLongitude] = useState<number>();
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: props.googleMapsApiKey,
    });

    useEffect(() => {
        if (props.selectedLocation) {
            setRecenterLatitude(props.selectedLocation.latitude);
            setRecenterLongitude(props.selectedLocation.longitude);
        }
    }, [props.selectedLocation]);

    if (!props.searchLocation || props.isLoading || !isLoaded) {
        return null;
    }

    const onMarkerSelect = (location: FuneralHome) => {
        props.setSelectedLocation(location);
        setRecenterLatitude(location.latitude);
        setRecenterLongitude(location.longitude);
    }

    const renderMarkers = () => {
        const markers = props.locations.map(location => {
            if (location.latitude && location.longitude) {
                const latLng = new google.maps.LatLng(location.latitude, location.longitude);
                return <Marker key={location.id} position={latLng} title={location.name + '-marker'} onClick={() => (
                    onMarkerSelect(location)
                )} />;
            }
        });
        return markers;
    };

    return (
        <GoogleMap
            mapContainerStyle={{
                width: '100%',
                height: '85vh',
            }}
            center={{
                lat: recenterLatitude ? recenterLatitude.valueOf() : props.searchLocation.latitude,
                lng: recenterLongitude ? recenterLongitude.valueOf() : props.searchLocation.longitude,
            }}
            zoom={10}
            onClick={() => (
                props.setSelectedLocation(undefined)
            )}
            onLoad={() => (
                props.setSelectedLocation(undefined),
                setRecenterLatitude(undefined),
                setRecenterLongitude(undefined)
            )}
            id='google-map'
        >
            {renderMarkers()}
            {props.selectedLocation && (
                <InfoWindow
                    position={new google.maps.LatLng(props.selectedLocation.latitude, props.selectedLocation.longitude)}
                    onCloseClick={() => props.setSelectedLocation(undefined)}
                >
                    <div className={classes.infoWindow}>
                        <div id={props.selectedLocation.id + '-' + props.selectedLocation.name + '-info-window-name'} className={classes.infoWindowName}>{props.selectedLocation.name}</div>
                        <div
                            id={props.selectedLocation.id + '-' + props.selectedLocation.name + '-info-window-address'}
                        >
                            {props.selectedLocation.address}, {props.selectedLocation.city}, {props.selectedLocation.state} {props.selectedLocation.zip}
                        </div>
                    </div>
                </InfoWindow>
            )}
        </GoogleMap>
    );
};

interface PropShape {
    isLoading: boolean;
    locations: FuneralHome[];
    searchLocation: SearchLocation | null;
    googleMapsApiKey: string;
    selectedLocation: FuneralHome | undefined;
    setSelectedLocation: (location: FuneralHome | undefined) => void;
}

ProviderMap.defaultProps = {
    // Set default values for props
    isLoading: true,
    locations: [],
    searchLocation: null,
};

export default ProviderMap;
